import React from "react";
import Carousel from "./Carousel"; // Import the custom carousel component
import "./Interventions.css"; // Ensure you have the updated CSS
import { useLanguage } from "../LanguageContext";

// Importing photo files for interventions (4 images for each card)
import photo1_1 from "../images/photo1_1.jpeg";
import photo1_2 from "../images/photo1_2.jpg";
import photo1_3 from "../images/photo1_3.jpg";
import photo1_4 from "../images/photo1_4.jpg"; // Images for first intervention

import photo2_1 from "../images/photo2_1.jpg";
import photo2_2 from "../images/photo2_2.jpg";
import photo2_3 from "../images/photo2_3.jpg";
import photo2_4 from "../images/photo2_4.jpg"; // Images for second intervention

import photo3_1 from "../images/photo3_1.jpeg";
import photo3_2 from "../images/photo3_2.jpeg";
import photo3_3 from "../images/photo3_3.jpeg";
import photo3_4 from "../images/photo3_4.JPG"; // Images for third intervention

import A1 from "../images/A1.jpeg";
import A2 from "../images/A2.jpeg";
import A3 from "../images/A3.jpeg";

// New intervention: Syracuse
import S1 from "../images/S1.jpeg"; 
import S2 from "../images/S2.jpeg";
import S3 from "../images/S3.jpeg";

function Interventions() {
  const { language } = useLanguage();
  const scrollContainerRef = React.useRef(null);

  const scroll = (direction) => {
    const { current } = scrollContainerRef;
    const scrollAmount = 350; // Width of a card + gap
    if (direction === 'left') {
      current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="interventions-section">
      <h2 className="section-title interventions-title">
        {language === 'ar' ? 'مداخلات' : language === 'fr' ? 'Interventions' : 'Interventions'}
      </h2>
      
      <div className="interventions-wrapper">
        <button className="interventions-nav-btn prev" onClick={() => scroll('left')}>&#8249;</button>
        
        <div className="interventions-container" ref={scrollContainerRef}>
          {/* New Intervention: Syracuse */}
          <div className="intervention-card">
            <Carousel
              images={[S1, S2, S3]} 
            />
            <div className="intervention-info">
              <h3 className="intervention-title">
                {language === 'ar' ? 'جامعة سيراكيوز' : language === 'fr' ? "Université de Syracuse" : 'Syracuse University'}
              </h3>
              <p className="description">
                {language === 'ar' ? 'مداخلة حول مساري الأكاديمي والأدبي' : language === 'fr' ? "Intervention sur mon parcours" : 'Presentation on my journey'}
              </p>
            </div>
          </div>
          <div className="intervention-card">
            <Carousel
              images={[photo2_1, photo2_2, photo2_3, photo2_4]} 
            />
            <div className="intervention-info">
              <h3 className="intervention-title">
                {language === 'ar' ? 'تجربة في الترجمة' : language === 'fr' ? 'Expérience de traduction' : 'Translation Experience'}
              </h3>
              <p className="description">
                {language === 'ar' ? 'تجربة في الترجمة مع مجلة The Hobos' : language === 'fr' ? 'Expérience de traduction avec le magazine The Hobos' : 'Translation experience with The Hobos Magazine'}
              </p>
            </div>
          </div>

          <div className="intervention-card">
            <Carousel
              images={[photo1_3, photo1_1, photo1_2, photo1_4]} 
            />
            <div className="intervention-info">
              <h3 className="intervention-title">
                {language === 'ar' ? 'مؤسسة جدارة' : language === 'fr' ? 'Fondation Jadara' : 'Jadara Foundation'}
              </h3>
              <p className="description">
                {language === 'ar' ? 'متحدثة في فعالية Her Day for Her مع مؤسسة جدارة' : language === 'fr' ? "Intervenante lors de la Masterclass Jadara Foundation" : 'Speaker at Jadara Foundation Masterclass'}
              </p>
            </div>
          </div>

          <div className="intervention-card">
            <Carousel
              images={[photo3_1, photo3_2, photo3_3, photo3_4]} 
            />
            <div className="intervention-info">
              <h3 className="intervention-title">
                {language === 'ar' ? 'مخيم كتاب الزيتون' : language === 'fr' ? 'The Olive Writers' : 'The Olive Writers'}
              </h3>
              <p className="description">
                {language === 'ar' ? 'مخيم كتاب الزيتون للكتابة الإبداعية' : language === 'fr' ? "The Olive Writers Summer Camp" : 'The Olive Writers Summer Camp'}
              </p>
            </div>
          </div>

          <div className="intervention-card">
            <Carousel
              images={[A1, A2, A3]} 
            />
            <div className="intervention-info">
              <h3 className="intervention-title">
                {language === 'ar' ? 'ورشات كتابة' : language === 'fr' ? "Ateliers d'écriture" : 'Writing Workshops'}
              </h3>
              <p className="description">
                {language === 'ar' ? 'ورشات تفاعلية في الكتابة الإبداعية' : language === 'fr' ? "Ateliers interactifs d'écriture créative" : 'Interactive creative writing workshops'}
              </p>
            </div>
          </div>
        </div>

        <button className="interventions-nav-btn next" onClick={() => scroll('right')}>&#8250;</button>
      </div>
    </div>
  );
}

export default Interventions;
